import script from "./TFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TFooter.vue?vue&type=script&setup=true&lang=ts"

import "./TFooter.vue?vue&type=style&index=0&id=50170db1&lang=scss"

const __exports__ = script;

export default __exports__